/*
  Сигнал «сессия закончилась посреди работы» (аудит 28.10.2026, раздел 5.3).

  Единственная проверка сессии стояла в каркасе при загрузке страницы. Если сессия
  истекала позже, каждый экран писал «войдите заново», но формы входа не было, а меню
  оставалось: попасть на вход можно было только перезагрузкой страницы.

  Клиент запросов (`client.js`) сообщает о любом ответе 401 сюда, каркас подписан и
  возвращает человека на вход. Отдельным файлом, а не внутри `client.js`: тот и без того
  велик, а подписчик у сигнала один.
*/

let listener = null

/** Каркас подписывается; возвращённая функция отписывает. */
export function onSessionLost(callback) {
  listener = callback
  return () => {
    if (listener === callback) listener = null
  }
}

/** Ответ сервера 401 на запрос уже вошедшего человека. */
export function notifySessionLost() {
  if (listener) listener()
}
